function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  className: "highlight highlight--stroke",
  d: "m21.858 15.3043-4.4034-7.53618 2.642-3.76812h8.8069l2.642 3.76812-4.4034 7.53618z",
  stroke: "#ffd200"
}), /*#__PURE__*/React.createElement("path", {
  className: "highlight highlight--stroke",
  d: "m17.4546 8.34778h14.0909",
  stroke: "#ffd200"
}), /*#__PURE__*/React.createElement("g", {
  className: "outline outline--stroke",
  stroke: "#c5cad1"
}, /*#__PURE__*/React.createElement("path", {
  d: "m18.3 16.1739c-5.4706 2.2193-9.3 7.3407-9.3 13.3156 0 8.0235 6.9294 14.5105 15.5 14.5105s15.5-6.487 15.5-14.5105c0-5.9749-3.8294-11.0963-9.3-13.3156"
}), /*#__PURE__*/React.createElement("path", {
  d: "m24.5 40.5217c6.4852 0 11.7424-4.8664 11.7424-10.8695s-5.2572-10.8696-11.7424-10.8696-11.7424 4.8665-11.7424 10.8696 5.2572 10.8695 11.7424 10.8695z"
})));

function SvgJewellery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJewellery);
export default __webpack_public_path__ + "static/media/jewellery.98689b09.svg";
export { ForwardRef as ReactComponent };